module.exports = __webpack_public_path__ + "48b80e98f07cacb52e346cb323d5891f.pdf";